import { print } from 'graphql';

import removeByIdConsultationMutation from '~/shared/graphql-queries/consultations/remove-by-id-consultation-mutation';
import type { BuilderType } from '~/types';

type RemoveByIdConsultationArgs = Readonly<{
  _id?: string;
}>;

export const consultationTagTypes = ['consultations'] as const;

export const getConsultationsQuery = (builder: BuilderType) => {
  return {
    removeByIdConsultation: builder.mutation<unknown, RemoveByIdConsultationArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(removeByIdConsultationMutation),
          variables: {
            _id: args?._id,
          },
        }),
      }),
    }),
  };
};
